import PageHero from '../components/PageHero.jsx';
import { FadeUp } from '../components/Motion.jsx';

const sections = [
  {
    id: 'definitions',
    title: '1. Definitions',
    paragraphs: [
      'This data protection declaration uses the terms defined by the European legislator in the General Data Protection Regulation (GDPR).',
      'a) Personal data — any information relating to an identified or identifiable natural person ("data subject"). An identifiable natural person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data or an online identifier.',
      'b) Data subject — any identified or identifiable natural person whose personal data is processed by the controller.',
      'c) Processing — any operation performed on personal data, whether or not by automated means, such as collection, recording, storage, retrieval, use, disclosure, restriction or erasure.',
      'd) Restriction of processing — the marking of stored personal data with the aim of limiting its processing in the future.',
      'e) Special categories of personal data — data revealing, among other things, information concerning health, as defined in Art. 9 GDPR.',
      'f) Pseudonymisation — processing personal data so that it can no longer be attributed to a specific data subject without additional information held separately.',
      'g) Controller — the natural or legal person which, alone or jointly with others, determines the purposes and means of the processing of personal data.',
      'h) Processor — a natural or legal person which processes personal data on behalf of the controller.',
      'i) Recipient — a natural or legal person to which personal data is disclosed.',
      'j) Consent — any freely given, specific, informed and unambiguous indication of the data subject\u2019s wishes by which they signify agreement to the processing of their personal data.',
    ],
  },
  {
    id: 'controller',
    title: '2. Controller and data protection contact',
    paragraphs: [
      'The controller for the purposes of the GDPR and other data protection provisions applicable in Member States of the European Union is:',
      'biolitec Pharma Ltd.\nUnit 9A, Plato Business Park\nDamastown\nDublin 15\nIreland',
      'Phone: +49 3641 519 5330',
      'Email: datenschutz@biolitec.com',
      'We have not designated a Data Protection Officer. For all questions relating to data protection, and to exercise the rights described in Section 9, please use the contact details above.',
    ],
  },
  {
    id: 'pharmacovigilance',
    title: '3. Adverse event reporting (pharmacovigilance)',
    paragraphs: [
      'If you submit an adverse event report through the form on this website, by email or by fax, we process the information you provide in order to meet our safety monitoring obligations as a marketing authorisation holder.',
      'Data we collect: your name, professional status, institution and contact details as the reporter; details of the medicinal product, dose and administration; a description of the adverse event including signs, symptoms, treatment and relevant laboratory data; and limited patient details, namely initials, age and gender. We ask reporters not to submit patients\u2019 full names, addresses or other directly identifying details.',
      'Legal basis: processing is necessary for compliance with a legal obligation to which we are subject (Art. 6(1)(c) GDPR). Where a report contains data concerning health, processing is necessary for reasons of public interest in the area of public health, in particular ensuring high standards of quality and safety of medicinal products (Art. 9(2)(i) GDPR). [INTERNAL REVIEW: legal basis to be confirmed by counsel before publication.]',
      'How the report reaches us: reports submitted through the form on this website are transmitted by email to our pharmacovigilance mailbox at pv@biolitecpharma.com. Transmission and storage take place on infrastructure located within the European Union.',
      'Recipients: reports are handled by our pharmacovigilance function and are transmitted to competent national and European health authorities, including the EudraVigilance database, where we are legally required to do so. We do not share adverse event reports with any other third party.',
      'Retention: adverse event reports are retained for as long as necessary to meet our pharmacovigilance obligations. [INTERNAL REVIEW: a defined retention period must be set by the pharmacovigilance quality management system and stated here before publication. Retention "until the mailbox is deleted" does not satisfy Art. 5(1)(e).]',
      'Your rights are limited in this context. Because safety data must be retained in order to meet a legal obligation and for reasons of public interest in public health, we are generally unable to erase an adverse event report on request. See Section 9.',
    ],
  },
  {
    id: 'contact',
    title: '4. Contact and medical information enquiries',
    paragraphs: [
      'This website publishes contact details enabling you to reach us by email, telephone or fax. If you contact us, the personal data you provide is processed for the purpose of handling and responding to your enquiry.',
      'Legal basis: our legitimate interest in responding to enquiries addressed to us (Art. 6(1)(f) GDPR), or, where the enquiry relates to a contract or pre-contractual steps, Art. 6(1)(b) GDPR.',
      'Where a medical information enquiry discloses a suspected adverse event, we are required to process it as a safety report and the provisions of Section 3 apply.',
      'Retention: correspondence is retained for as long as necessary to handle the enquiry and to meet any applicable legal obligation. [INTERNAL REVIEW: define a retention period for general correspondence.]',
      'This data is not passed to third parties except where required to meet a legal obligation.',
    ],
  },
  {
    id: 'server-logs',
    title: '5. Server log files',
    paragraphs: [
      'When this website is accessed, technical data is automatically recorded in server log files. This may include the browser type and version used, the operating system, the referring website, the sub-pages visited, the date and time of access, the IP address and the internet service provider of the accessing system.',
      'We do not use this data to draw conclusions about individual visitors. It is used to deliver the content of the website correctly, to ensure the security and long-term stability of our systems, and to provide law enforcement authorities with the information necessary for prosecution in the event of a cyber-attack.',
      'Legal basis: our legitimate interest in the secure and reliable operation of this website (Art. 6(1)(f) GDPR).',
      'Retention: server log data is retained by our hosting platform for 60 days, after which it is deleted.',
    ],
  },
 {
    id: 'cookies',
    title: '6. Cookies and browser storage',
    paragraphs: [
      'This website does not use cookies.',
      'We do not use analytics, measurement, advertising or marketing tools, and we do not embed social media plug-ins. Your visit is not tracked and no profile is built about you.',
      'The only data stored in your browser is a single entry recording your acknowledgement of our privacy notice, so that the notice is not shown to you on every visit. This is stored using your browser\u2019s local storage rather than a cookie, is strictly necessary for the website to respect your choice, and does not require consent.',
      'You can clear this at any time through your browser settings.',
    ],
  },
  {
    id: 'processors',
    title: '7. Hosting, email and processors',
    paragraphs: [
      'This website is hosted on the Zoho Catalyst platform, operated by Zoho Corporation, using data centre infrastructure located within the European Union.',
      'Adverse event reports submitted through this website are transmitted by email using the email service provided as part of that platform.',
      'A data processing agreement meeting the requirements of Art. 28 GDPR is in place with our hosting and email provider. Information about Zoho\u2019s GDPR compliance is published at zoho.com/gdpr.',
      'Personal data processed through this website is stored within the European Economic Area. We do not transfer personal data to recipients outside the EEA.',
    ],
  },
  {
    id: 'security',
    title: '8. Security of processing',
    paragraphs: [
      'We have implemented technical and organisational measures intended to protect the personal data processed through this website. Data submitted through the adverse event report form is transmitted over an encrypted connection.',
      'Please note that internet-based data transmission may in principle have security gaps, and absolute protection cannot be guaranteed. You are free to transmit personal data to us by alternative means, for example by telephone or fax, using the contact details published on this website.',
    ],
  },
  {
    id: 'rights',
    title: '9. Your rights as a data subject',
    paragraphs: [
      'Under the GDPR you have the right to obtain confirmation as to whether personal data concerning you is being processed; to obtain access to that data and information about the purposes, categories, recipients and storage period; to obtain rectification of inaccurate data and completion of incomplete data; to obtain erasure; to obtain restriction of processing; to data portability; and to object to processing based on legitimate interests.',
      'Where processing is based on your consent, you may withdraw that consent at any time. Withdrawal does not affect the lawfulness of processing carried out before the withdrawal.',
      'Important limitation: the right to erasure does not apply where processing is necessary for compliance with a legal obligation, or for reasons of public interest in the area of public health (Art. 17(3)(b) and (c) GDPR). This means we are generally unable to delete an adverse event report once it has been submitted, and we may be required to retain and transmit it to health authorities.',
      'To exercise any of these rights, please contact us using the details in Section 2.',
      'You also have the right to lodge a complaint with a data protection supervisory authority. As our establishment is in Ireland, the competent authority is the Data Protection Commission, 6 Pembroke Row, Dublin 2, D02 X963, Ireland (www.dataprotection.ie).',
    ],
  },
  {
    id: 'legal-basis',
    title: '10. Legal bases for processing',
    paragraphs: [
      'Art. 6(1)(a) GDPR applies where we obtain consent for a specific processing purpose.',
      'Art. 6(1)(b) GDPR applies where processing is necessary for the performance of a contract to which you are party, or for pre-contractual steps taken at your request.',
      'Art. 6(1)(c) GDPR applies where we are subject to a legal obligation, in particular our pharmacovigilance obligations as described in Section 3.',
      'Art. 6(1)(f) GDPR applies where processing is necessary for the purposes of our legitimate interests, except where those interests are overridden by your interests or fundamental rights and freedoms.',
      'Art. 9(2)(i) GDPR applies to the processing of data concerning health where this is necessary for reasons of public interest in the area of public health, including ensuring high standards of quality and safety of medicinal products.',
    ],
  },
  {
    id: 'legitimate-interests',
    title: '11. Legitimate interests pursued',
    paragraphs: [
      'Where processing is based on Art. 6(1)(f) GDPR, our legitimate interests are responding to enquiries addressed to us and maintaining the security, availability and integrity of this website and the systems supporting it.',
    ],
  },
  {
    id: 'provision',
    title: '12. Whether you are obliged to provide personal data',
    paragraphs: [
      'You are not required to provide personal data in order to browse this website.',
      'Where you choose to submit an adverse event report, certain fields are marked as required. Without this information we may be unable to assess the report or to meet our reporting obligations to health authorities. Providing the report itself is voluntary.',
    ],
  },
  {
    id: 'automated-decisions',
    title: '13. Automated decision-making',
    paragraphs: [
      'We do not use automated decision-making or profiling within the meaning of Art. 22 GDPR.',
    ],
  },
  {
    id: 'changes',
    title: '14. Changes to this policy',
    paragraphs: [
      'We may update this policy to reflect changes in our processing activities or in applicable law. The current version is always available on this page.',
      'Last updated: 11 August 2026',
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <>
      <PageHero
        eyebrow="LEGAL"
        title="Privacy policy"
        subtitle="How biolitec Pharma Ltd. collects, uses and protects personal data."
      />

      <div className="page-shell">
        <div className="page-grid">
          <div className="page-main">
            <FadeUp>
              <section className="page-section" id="introduction">
                <p className="page-body">
                  Data protection is a high priority for biolitec Pharma Ltd. Most of this
                  website can be used without providing any personal data. Where you choose
                  to contact us or to submit an adverse event report, we process the
                  personal data you provide as described below.
                </p>
                <p className="page-body">
                  This policy explains what personal data we collect, why we process it,
                  the legal basis for doing so, how long we keep it, who receives it, and
                  the rights available to you under the General Data Protection Regulation.
                </p>
              </section>
            </FadeUp>

            {sections.map((s) => (
              <FadeUp key={s.id}>
                <section className="page-section" id={s.id}>
                  <h2 className="page-section-title">{s.title}</h2>
                  {s.paragraphs.map((p, i) => (
                    <p key={i} className="page-body legal-prewrap">{p}</p>
                  ))}
                </section>
              </FadeUp>
            ))}

            <FadeUp>
              <div className="inline-note">
                <p>
                  For questions about this policy, or to exercise any of the rights
                  described above, contact{' '}
                  <a href="mailto:datenschutz@biolitec.com">datenschutz@biolitec.com</a>.
                </p>
              </div>
            </FadeUp>
          </div>

          <div className="page-aside">
            <nav className="toc" aria-label="On this page">
              <h2 className="toc-title">On this page</h2>
              <ul className="toc-list">
                {sections.map((s) => (
                  <li key={s.id}>
                    <a className="toc-link" href={`#${s.id}`}>{s.title}</a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}